<template>
    <div class="drawerLayer" v-show="visible">
        <div class="mask" @click="close();"></div>
        <div class="bottomDrawer white_bg">
            <div class="">
                <header class="header generalPagePaddingH paddingV16">
                    <div class="flexLayout">
                        <div style="width: 16px;">
                            <i class="icon closeIcon" @click="close()"></i>
                        </div>
                        <div class="flexItem alignCenter grey10 fWeight600">绑定手机号</div>
                        <div style="width: 16px;">
<!--                            <i class="icon closeIcon" @click="close()"></i>-->
                        </div>
                    </div>
                </header>
                <div class="body">
                    <div class="warnArea f12" style="padding: 0 22px">
                        <i class="icon warnIcon marginR4 relative" style="top: 3px; width: 16px; height: 14px;"></i>
                        参照国家标准《个人信息标准》需绑定手机号码
                    </div>
                    <div style="padding: 48px 6vw 34px;">
                        <form class="phoneBindForm" action="javascript:;" @submit="bindPhone()">
                            <table class="w100p f16" cellpadding="0" cellspacing="0">
                                <tr :class="{active : phoneInputRow.active}">
                                    <th width="64" style="padding-bottom: 13px;">手机号</th>
                                    <td style="padding-bottom: 13px;">
                                        <input type="text" class="inputbox grey20 placeholderColor8994A9" placeholder="请输入手机号" required=""
                                               style="width: 120px;" v-model="phone"
                                               @focus="phoneInputRow.active=true" @blur="phoneInputRow.active=false"/>
                                        <i class="icon closeIcon size16 fr" @click="phone=''"></i>
                                    </td>
                                </tr>
                                <tr :class="{active : verifyCodeInputRow.active}">
                                    <th style="padding-top: 32px; padding-bottom: 8px;">验证码</th>
                                    <td style="padding-top: 32px; padding-bottom: 8px;">
                                        <input type="text" class="inputbox grey20 placeholderColor8994A9" placeholder="请输入验证码" required=""
                                               style="width: 80px;" v-model="verifyCode"
                                               @focus="verifyCodeInputRow.active=true"
                                               @blur="verifyCodeInputRow.active=false"
                                                @change="onChangeVerifyCode"/>
                                        <button class="getVerifyCodeButton fr" type="button" @click="getVerifyCode()"
                                                :disabled="phone.length < 1">
                                            <span v-if="verifyCodeSeconds == 0">获取验证码</span>
                                            <span v-if="verifyCodeSeconds">{{verifyCodeSeconds}}S</span>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" style="padding-top: 17px;">
                                        <label class="font13r">
                                            <input class="checkbox orangeCheckbox" type="checkbox" v-model="agreeServiceProtocol"/>
                                            绑定手机即同意
                                            <a class="orange" :href="externalApp.oldShixun.baseUrl + 'html/txt.html?VIP=VIP'">《师讯平台服务协议》</a>
                                        </label>

                                    </td>
                                </tr>
                            </table>

                            <div style="margin-top: 54px;">
                                <button class="block submitButton" type="submit">确定</button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

import moment from 'moment';

import drawerPart from '../part/drawerPart';

// api
import userApi from '@api/user';

// data
import externalApp from '@data/externalApp';

// platformApi
import requestManager from '@comp/platformApi/requestManager'
import timerManager from "@comp/platformApi/timerManager";
import storageManager from "@comp/platformApi/storageManager";

// util
import appHelper from "../../util/appHelper";
import consoleApi from "@comp/platformApi/consoleApi";

const config = {
    // unit: second
    verifyCodeSendDelay : 60
};

export default {
    name: "bindPhoneDrawer",
    extends : drawerPart,
    data() {
        return {
            apiConfig : config.apiConfig,
            phone : '',
            verifyCode : '',
            phoneInputRow : {
                active : false
            },
            verifyCodeInputRow : {
                active : false
            },
            verifyCodeSeconds : 0,
            countDownTimer : null,
            externalApp : externalApp,
            isBindedPhone : false,
            agreeServiceProtocol : false
        }
    },
    methods : {
        getVerifyCode() {

            if (!this.phone)
            {
                return;
            }

            // check timer
            if (this.countDownTimer)
            {
                appHelper.showHint('验证码' + config.verifyCodeSendDelay + '秒内有效');
                return;
            }

            let sendVerifyCodeApi = userApi.sendVerifyCodeApi;
            sendVerifyCodeApi.data = {
                phone : this.phone
            };

            requestManager.request(sendVerifyCodeApi, (error, result) => {
                if (error)
                {
                    appHelper.generalAjaxError(error);
                    return;
                }

                let errorCode = result.errorCode || 0;
                if (errorCode)
                {
                    appHelper.showHint(result.msg);
                    return;
                }

                appHelper.showHint('发送成功，请查收。');

                this.verifyCodeSeconds = config.verifyCodeSendDelay;
                this.countDownTimer = timerManager.setInterval(() => {
                    this.verifyCodeSeconds--;

                    if (this.verifyCodeSeconds == 0)
                    {
                        timerManager.clearInterval(this.countDownTimer);
                        this.countDownTimer = null;
                    }
                }, 1 * 1000);
            });

        },

        onChangeVerifyCode() {

            if (this.verifyCode.length > 6)
            {
                this.verifyCode = this.verifyCode.substr(0, 6);
            }
        },

        bindPhone() {
            if (!this.phone)
            {
                return;
            }

            let phone = this.phone;
            let verifyCode = this.verifyCode;

            if (verifyCode.length > 8)
            {
                appHelper.showHint('验证码过长，请检查。');
                return;
            }

            let verifyPhoneCodeApi = userApi.verifyPhoneCodeApi;
            verifyPhoneCodeApi.data = {
                // capchaType  : 'SMS',
                phone   : phone,
                code    : verifyCode
            };
            requestManager.request(verifyPhoneCodeApi, (error, result) => {
                if (error)
                {
                    appHelper.generalAjaxError(error);
                    return;
                }

                let errorCode = result.errorCode || 0;
                if (errorCode)
                {
                    appHelper.showHint(result.msg);
                    return;
                }

                let bindPhoneApi = userApi.bindPhone;
                bindPhoneApi.data = {
                    phone : phone,
                    code : verifyCode
                }

                requestManager.request(bindPhoneApi, (error, result) => {

                    if (error)
                    {
                        appHelper.generalAjaxError(error);
                        return;
                    }

                    let errorCode = result.errorCode || 0;
                    if (errorCode)
                    {
                        appHelper.showHint(result.msg);
                        return;
                    }
                    this.isBindedPhone = true;

                    storageManager.setItem('bindPhoneTime', moment().format('YYYY-MM-DDTHH:mm:ss'));

                    this.$emit('bindSuccess');
                });
            });
        }
    },
    mounted() {
        appHelper.checkLogin((error, result) => {

            consoleApi.log('[bindPhoneDrawer] check login callback');

            if (error)
            {
                return;
            }

            if (!result)   // 游客
            {
                consoleApi.log('result:', result);
                return;
            }

            requestManager.request(userApi.isBindPhone, (error, result) => {
                if (error)
                {
                    return;
                }

                this.isBindedPhone = result.data;
            });
        });

    }
}
</script>

<style lang="scss" scoped>
.orange {
    color: hsla(36, 100%, 57%, 1);
}
.header {
    .closeIcon {
        width: 14px;
        height: 14px;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACFklEQVRoge2ZQU/bMBhALWCdhPgZvfnk7305k/MkdhgwumqI/vkxpE2CaTsgtaG7xCjqbEiKnWRSntRDqzp+L0nbNDZmYmIiCHBsrT0Z2sNaewIcdxqkqh+AP8CjiHzO5PYqIvIJeAR+q2rZdtwhcAts68daVc8zegZR1Qtg3fC4NcYcvDoQeAc8NAb6iIv82s8OlzvyW+DeGHPYdgNLEakCEdmPRGDPb4EnEbnqtCERWfUdISJXEfnVvhsMRgCXadWf5TfJ5BsbDkVsnHNf0qhnlG9MkC0iu3xjouQRIfl6jpuU7s0Jk0XE5FX1Ood7c+I3Rwwm3xDYO8I5txhU3rNPBLAEqsHlPV0iRifvaRMxWnnPSxEheWA88p5YROC1ClgO7RtERL4GflX/D3lPfdr8E1EfiXHLG2OMql4HTpvkF4BZeEF+/BEh+fr57uk0vojInq+AZeQzMZ6IiPzGObfw74lFJL/m70pMPvQHPBQhItVgEV3kPaOJAG66ynsGjxCRFfC0j7xnsIgU8p7eI1LKe3qLiMiv3yLvyR4Rk095szdbRB/ynuQRfcp7kkWo6qJveQ+BtYE6ot1KkbV2BvzalSfDHekYkTWCe2vtrM34A+B786uyz9UZj6qe70R8M22WmIwxpiiKU+AO+CEiZ3lV4zjnPgI/gbuiKE47DS7L8mg+n7/P5NYaa+2sLMujoT0mJsbKX2RBsPwpegpvAAAAAElFTkSuQmCC');
    }
}
.warnArea {
    background: hsla(3, 100%, 96%, 1);
    color: hsla(2, 100%, 64%, 1);
    height: 22px;
    line-height: 22px;

    .warnIcon {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAcCAYAAAAAwr0iAAACeklEQVRIiaVXPWtbMRR9g0tL8FrIFg+G9Ad0KfGgIVRXyruyCZ2yxLTgfkB/RQeH2JD8kxg6ZfLQ0XO7ZPCULhlNU0KG00Hye8+2+iQ5gre8+3V079XVUZYFFoRowKgDMA2R0xRMc7Bc2I/m7t8QRh1AiEbIX/SygenUBiREfnMYOn16cCPbMDSrOL4ByzGMJvSoBSGaEKKJHrVgNIHl2Oo4fUMzGNneLnhOAkx3ZWDqR9sy9StA7pCT2Cb4o3MwgRDNRPwZhGiCaeJ8PEaDgJHtYudGXaYG3vSnLotMhMrhGm5Z80kA6CcwLcC0gHn7uVZ3mQlDs3oAtna25oG0g+ljpTm/1Oracix7ov8/pUblqPmV/GABowYJ+nPvnABTZ7n7kLMsyzJ01bsyA/okyqbMQscnHFqhHEc5O5KHJQCl4gDIseuFbz4AP6xQU5Qzo18XAHJ6E2lDzmbqA2Dr36NWnDPZLjPAr6JsetRa9oEPwF8wIXboQKmXBQCtd6Ns7GkAWC42hXkB4EWUs8HgWQHgq3r+dACJJXA2f2DUfbR+oAS2CY/kYQKAWzD9jtavb0J55oSjeIf0E7n6Fa3PNHIlOPMJkwaRA7APQ/sJAGoGUeIoTl3BUbymFL6MtN6FoXMYOg8dQ9f94c25LLjrWF4FdnRduQ2v63Xld6dXfx1n2TohkRc1AG4qALx9Y/mFvIgmJIXhCiWTV75ygOkDmB7A9ACj3nuCNys7j6dkayBKUuqh2WDeAfPOxv9VGp9OSktHsl32RMGOR+iSxLHeK2j5sd5Dl6Q759XSbE/LV4DY05HyMEmi8XEg7AnpuIm5+TRjmjpZZ5un2T+CtLdIU2jkOgAAAABJRU5ErkJggg==');
    }
}
.phoneBindForm {
    color: hsla(219, 16%, 60%, 1);

    table {
        tr {
            &.active {
                th, td {
                    border-bottom: solid 1px hsla(36, 100%, 57%, 1);
                }
            }

            th, td {
                border-bottom: solid 1px hsla(219, 26%, 79%, .4);
                line-height: 26px;
            }
        }
        tr:last-child {
            th, td {
                border-bottom: none;
            }
        }
    }

    .inputbox {

        font-size: 16px;
        border: none;
        background: transparent;
        outline: none;
    }

    .closeIcon {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAD80lEQVRYhcWXz28TRxTHJ4qIVIQa/gCQQII/or0RqSgVqcS1FYciJAIHhEAiTUiRIg4Ruw1JKLshdhIFO/zaEfaGOJ7ZtUtmZ1YlqWRCI3tmraY5EEscgsRf0Oz24GwI9tpeu2n7pHeaN+/znTdvvM8AhDQIYXtmZeOkScRZ03YuYla4hqgYRFQMYla4ZtrORZOIsxkqTkII28PmbWipVO5ghjqnMXX6MeVD4dzpR9Q5/epV6bN/wm7DvzpfYIsPhAdXCzFp/ksAQFvTp8aMn2sdXOGMn0vl3h0MBcfEOYZt5/q+wX23+XVMnGN14dnsRidm4sa+w3crIW5ksxudgXAIeQemTu+/Bv/ovZDzjioBpiW+qgx+lGRz49FkKf6cPmsWFH9On41Hk6VHuh2vXDMp7/oETsjWIUzFj5WByuzia0nRPFnR3FjCgmHhsYQFZUVzJUXzlNnF15XrBuM3Cdk6tCvAYOJMUCI9szoyGklsSYrmSYq2HUZELGFBSdG2JUXzRiOJLT2zOhIUt8jyZ3buHrZjVvutl0UkfRHu9NPsYq3YqSdZQ1LLJ78bSb6vBS83JB+A0GsHBuEnGp1Kz6yO3I0k3++I8KaeZI1A+M56Q7h/FYSfACZxesLcaz0RrcAx5UPI4l8DTPMXwjZXkIhW4WXPXwAGFVfDb6gWIamwRTgfMqi4ChAVg81s8kWMTCY++CJ+epD4sPDL73eazYOoGAT1XkAtn4hjW1Khe+djFdzJx+bLZvNgxgcAYvxKU/CHaFlSoSspmjcW1UtjUb3ki5h4iJabqgDjV4Bh8fNhN6iz6RVJha6sQnd0St9MLa0Np5bWhsem9E1ZhW7TIgj/HhiEd4crO9qFj0Xn36aW1ob9tdTS2vBoRN+UVc2VVOiqs+mVMDnThHcDkxaPNy57+rdyw1XD94oYi86/lXeuR401FmHS4nEAoVf3p1iNpVckRfNkVXPvTb8oBsH3ihiffvGHpJRFTMRQbRGMD+wOr8gqfBMUNPkYv5QUzZVV6N6fmRfIKtxu2FhW4fa96QUhq9CVVc2dnMOBr8MkTs8nn2OD8ZuVQQ/imMmq9tf9mYVQ8L0ifp6ZdyRF247MYatyvepzDAAAhlU8FZTsaWo5GrqrK0TU2mtYxVNVE1EulzuAKf8PRjKnN5fLHag9lFr/01DqGyLrRwxL9O033GCiD5H1I3Xhvun6m8MG45f2D168pJM3h0PBfYOcd5jE6TGswq3WwYVbpu30QBgwhoe1bDbXadi826Dih/AvQPSlbd6N0PrnLYMrzfO8NpP+eRRR3pWxnW8RE5cx5f2Y8n7ExGWD8u8Q5V0mzR/1PC/0n9G/AWyXNi1VR5E0AAAAAElFTkSuQmCC');
    }
    .getVerifyCodeButton {
        width: 82px;
        height: 26px;
        line-height: 26px;
        background: #FFFFFF;

        border-radius: 2px;
        text-align: center;

        font-size: 14px;
        padding: 0;

        border: 1px solid hsla(36, 100%, 57%, 1);
        color: hsla(36, 100%, 57%, 1);
        &:disabled {
            border: 1px solid #B8C2D6;
            color: hsla(220, 27%, 78%, 1);
        }
    }
    .submitButton {
        width: 100%;
        height: 42px;
        line-height: 42px;
        border-radius: 21px;
        padding: 0;
        background: linear-gradient(270deg, #FFBD5A 0%, #FF8853 100%);
        font-size: 16px;
        color: white;
        border: none;
    }
}
</style>

